import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { QuestaoFormComponent } from 'src/app/pages/questao-form/questao-form.component';

@Injectable()
export class QuestaoGuard
  implements CanDeactivate<QuestaoFormComponent> {
  canDeactivate(
    component: QuestaoFormComponent
  ): Observable<boolean> | boolean {
    if (!component.visualizar) {
      if (component?.salvar) { return true; }
       if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    }
    else { return true; }
  }
}
